import { RootState } from '@store/reducers';
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import './benefeciaryUnderMobNo.css'
import Button from '@components/common/Button';
import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { setBeneficiaryAuthType, updateAncService, updateChild, setTsnID } from '@store/actions/beneficiaryAction';
import TableComponent from './table';
import { GENDER } from '@constants/index';
import { benef_const } from '@constants/beneficiaryConstant';
import { postDataJSON } from '@services/CommonApiService';
import endpoints from '@config/endpoints';
import { errorLogger } from '@utils/applicationLogUtils';
import { toast } from 'react-toastify';


interface showModalProps {
    showModal: boolean;
    handleClose: (authType: string) => void;
};

const BenefeciaryUnderMobNo = ({ showModal, handleClose }: showModalProps) => {
    const dispatch = useDispatch();
    const beneficiary = useSelector((state: RootState) => state.beneficiary);
    const isBneficaryChild = useSelector((state: RootState) => state.beneficiary?.isBneficaryChild);
    const [invalidGenderMessage, setInvalidGenderMessage] = useState<string>('');
    const isBeneficiarySelected = useSelector((state: RootState) => state.beneficiary?.beneficiarySelected);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const txnId = useSelector((state: RootState) => state.beneficiary?.tsnId);
    const handleAuthClick = (authType: string) => {
        dispatch(setBeneficiaryAuthType(authType));
        handleClose(authType);
        setInvalidGenderMessage('');
    };
    const handleBackClick = (): void => {
        handleAuthClick('back')
        dispatch(updateAncService('beneficiarySelected', false));
        dispatch(updateAncService('isBneficaryChild', false));
        setInvalidGenderMessage('');
    }

    const handleDiscardClick = (): void => {
        handleAuthClick('')
        dispatch(updateAncService('beneficiarySelected', false));
        dispatch(updateAncService('isBneficaryChild', false));
        dispatch(updateChild('isChildRegistration', false));
        setInvalidGenderMessage('');
    }
    const beneficiaryData = useSelector((state: RootState) => state.beneficiary?.beneficiaryData);

    const handleNextClick = async () => {
        if (beneficiary?.beneficiaryGender === GENDER.FEMALE && beneficiaryData[0]?.gender !== GENDER.female) {
            setInvalidGenderMessage(benef_const.genderMisMatchFemale)
        }
        else if (beneficiary?.beneficiaryGender === GENDER.MALE && beneficiaryData[0]?.gender !== GENDER.male) {
            setInvalidGenderMessage(benef_const.genderMisMatchMale)
        }
        else 
            if (isBneficaryChild) {
            handleAuthClick('');
        } else {
            if (beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.face_Authentication) {
                try {
                    setIsLoading(true);
                    const selectedBeneficiary = beneficiaryData[0];
                    sessionStorage.setItem('faceAuthSearchTxnId', txnId);
                    const requestOtpPayload = {
                        index: String(selectedBeneficiary?.index),
                        txnId: txnId
                    };
                    
                    const response = await postDataJSON<any>(`${endpoints.faceAuthRequestOtp}`, requestOtpPayload);
                    
                    const newTxnId = response.data?.txnId || response.data?.txn_id;
                    const deepLink = response.data?.faceAuthDeepLink;
                    
                    if (newTxnId) {
                        dispatch(setTsnID(newTxnId));
                        if (deepLink) {
                            sessionStorage.setItem('faceAuthDeepLink', deepLink);
                            sessionStorage.setItem('faceAuthBeneficiaryIndex', String(selectedBeneficiary?.index));
                        }
                    }
                    
                    setIsLoading(false);
                    handleAuthClick('submit');
                    dispatch(updateAncService('beneficiarySelected', false));
                    dispatch(updateAncService('isBneficaryChild', false));
                } catch (error: any) {
                    setIsLoading(false);
                    toast.error('Failed to request OTP. Please try again.', {
                        position: "top-center",
                    });
                    errorLogger(error?.response?.data || error?.response || error);
                }
            } else {
                handleAuthClick('submit');
                dispatch(updateAncService('beneficiarySelected', false));
                dispatch(updateAncService('isBneficaryChild', false));
            }
        }
    }

    return (
        <>
            <div className="modal_verification_beneficiaries">
                <Modal
                    show={showModal}
                    onHide={() => handleAuthClick('')}
                    dialogClassName={'verification-card-modal'}
                    centered={true}
                    backdrop="static"
                >
                    <Modal.Header>
                        <div className='mobNo_card_header'>
                            <div className="d-flex align-items-center beneficiary_back_button" onClick={handleBackClick}>
                                <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                                <span className="ms-1">Back</span>
                            </div>
                            <div className="d-flex align-items-center beneficiary_discard_button" onClick={handleDiscardClick}>
                                <span className="me-0">Discard</span>
                                <i className="bi bi-x" ></i>
                            </div>

                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {!invalidGenderMessage && <div className="beneficiary-table">
                            <h1>Select a Beneficiary</h1>
                            <TableComponent data={beneficiaryData} />
                            {beneficiaryData.length === 1 &&
                                <div className="beneficiaryUnderMobNo-buttons">
                                    <Button
                                        onClick={handleNextClick}
                                        disabled={!isBeneficiarySelected || isLoading}
                                        id="beneficiaryUnderMobNo-Next-button"
                                        buttonName={isLoading ? 'Loading...' : 'Next'}
                                        colorType={'primary'}
                                        icon={''}
                                        iconPosition={''}
                                    />
                                </div>
                            }
                        </div>}
                        {invalidGenderMessage !== '' &&
                            <div>
                                {invalidGenderMessage}
                                <div className="beneficiary-otp-page-close-button">
                                    <Button
                                        onClick={() => handleAuthClick('close')}
                                        disabled={false}
                                        id=""
                                        buttonName={'Close'}
                                        colorType={'primary'}
                                        icon={''}
                                        iconPosition={''}
                                    />
                                </div>
                            </div>}
                    </Modal.Body>
                </Modal>
            </div>

        </>
    );
};

export default BenefeciaryUnderMobNo;